import { Btn } from 'components/Btn'
import { Icon } from 'components/Icon'
import React from 'react'
import styled, { css } from 'styled-components'
import { AvatarThumb, AvatarThumbProps } from './Avatar.thumb'

type AvatarStyleProps = {
	size: string
	fontSize: string
}
export const avatarStyles = css<AvatarStyleProps>`
	.avatar-thumb {
		overflow: hidden;
		border-radius: ${props => props.size};
		width: ${props => props.size};
		height: ${props => props.size};
		min-width: ${props => props.size};
		max-width: ${props => props.size};
	}
	img {
		display: block;
		height: 100%;
		width: 100%;
		object-fit: cover;
	}
	.icon {
		position: absolute;
		top: -2px;
		right: -20px;
		width: 2rem;
		color: ${props => props.theme.colors.secondary.val};
	}
	&.__no-pic {
		.avatar-thumb {
			background: ${props => props.theme.colors.secondary.val};
			color: ${props => props.theme.colors.white.val};
			font-size: ${props => props.fontSize};
			font-weight: 400;
			display: flex;
			align-items: center;
			justify-content: center;
			.icon {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
			}
		}
	}
	&.__loading {
		.avatar-thumb {
			background: ${props => props.theme.colors.midNeutral.light().val};

			.icon,
			.user-initials,
			img {
				opacity: 0;
			}
		}
	}
`

const AvatarView = styled.div`
	${avatarStyles}
`

export type AvatarProps = {
	className?: string
	size?: 'sm' | 'm' | 'l'
	user?: AvatarThumbProps['user']
	isLoading?: AvatarThumbProps['isLoading']
	onEditClick?: () => void
}
export const Avatar = ({ className, size = 'm', user, isLoading, onEditClick }: AvatarProps) => {
	const { imageUrl } = user || {}
	const pxSize = size === 'sm' ? '37px' : size === 'm' ? '51px' : size === 'l' ? '92px' : '51px'
	const fontSize = size === 'sm' ? '16px' : size === 'm' ? '22px' : size === 'l' ? '39px' : '22px'
	const imgUrl = imageUrl

	return (
		<AvatarView
			className={`avatar${className ? ` ${className}` : ''}${imgUrl ? ' __has-pic' : ' __no-pic'}${
				isLoading ? ' __loading' : !user ? ' __empty' : ''
			}`}
			size={pxSize}
			fontSize={fontSize}
		>
			{onEditClick ? (
				<Btn onClick={onEditClick} title='Upload photo'>
					<AvatarThumb isLoading={isLoading} user={user} />
					<Icon type='pencil' />
				</Btn>
			) : (
				<AvatarThumb isLoading={isLoading} user={user} />
			)}
		</AvatarView>
	)
}
